// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountAvatarUpsellBadge-cls1_T-u","cls2":"AccountAvatarUpsellBadge-cls2_lDd AccountAvatarUpsellBadge-cls1_T-u"};